import { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { useData } from '../../contexts/data-context/use-data';
import { useUserInfo } from '../../contexts/user-context/use-user-info';
import { Inline } from '../../design-system/inline/inline';
import { Stack } from '../../design-system/stack/stack';
import { cn } from '../../utils/cn';
import AvatarDropdown from './components/avatar-dropdown';
import { CurrencySelector } from './currency-selector';

interface HeaderProps {
  children?: ReactNode;
}

const Header = ({ children }: HeaderProps) => {
  const navigate = useNavigate();
  const { authenticatedInfo, mutations } = useUserInfo();
  const { data, isLoading } = useData();

  if (isLoading) {
    return null;
  }

  if (!data) {
    return null;
  }

  return (
    <header
      className={cn('h-auto pb-5 pl-5 pr-0 pt-5', {
        'pb-2': children,
      })}
    >
      <Stack space={4}>
        <Inline align="center" justify="between" wrap="nowrap" className="mb-8 w-full pr-5">
          <div className="flex items-center gap-4">
            {authenticatedInfo?.activeOrg?.logoUrl && (
              <img
                src={authenticatedInfo?.activeOrg?.logoUrl}
                alt=""
                loading="eager"
                fetchPriority="high"
                style={{ maxHeight: '60px' }}
              />
            )}
            <p className="text-lg font-semibold text-gray-800">{authenticatedInfo?.activeOrg?.name}</p>
          </div>

          <Inline align="center" space={4}>
            <div className="flex-0 min-w-28">
              <CurrencySelector />
            </div>

            <AvatarDropdown
              avatarUrl={authenticatedInfo?.picture}
              logout={mutations.logout}
              name={authenticatedInfo?.name}
              email={authenticatedInfo?.email}
              onTeamClick={() => navigate('/dashboard/team')}
              onSwitchOrgClick={() => {
                window.location.href = '/auth/login';
              }}
              onIntegrationsClick={() => navigate('/dashboard/integrations')}
            />
          </Inline>
        </Inline>

        {children}
      </Stack>
    </header>
  );
};

export default Header;
